import {
    locationSelector,
    locationChangedSelector
} from '@zoopla/redux-reducer-filters';
import { polyencSelector } from '@zoopla/redux-reducer-search-results';
import { useSelector } from 'react-redux';

const useSearchLocation = (customName = 'Custom area') => {
    const { selectedValue: locationValue } = useSelector(locationSelector);
    const { selectedValue: locationChanged } = useSelector(
        locationChangedSelector
    );

    const polyenc = useSelector(polyencSelector);

    const value =
        polyenc && locationChanged === 'false' ? customName : locationValue;

    return value;
};

export default useSearchLocation;
